class CustomCollapsibleContent extends HTMLElement {
  constructor() {
    super();
    this.currentOpenElement = null; // To track the currently open <custom-details> element
    this.closePrevious = this.hasAttribute('data-close-previous'); // Check if the attribute exists
    this.addEventListener('click', this.handleAccordionClick.bind(this));
  }

  handleAccordionClick(event) {
    const clickedSummary = event.target.closest('summary');
    if (!clickedSummary) return;

    const customDetails = clickedSummary.closest('custom-details');
    if (!customDetails) return;

    const isExpanded = customDetails.classList.contains('open');

    // If `data-close-previous` is set, close the currently open <custom-details>, if any
    if (this.closePrevious && this.currentOpenElement && this.currentOpenElement !== customDetails) {
      this.currentOpenElement.classList.remove('open');
      this.currentOpenElement.querySelector('summary').setAttribute('aria-expanded', 'false');
    }

    // Toggle the clicked <custom-details>
    if (isExpanded) {
      customDetails.classList.remove('open');
      clickedSummary.setAttribute('aria-expanded', 'false');
      if (this.currentOpenElement === customDetails) {
        this.currentOpenElement = null;
      }
    } else {
      customDetails.classList.add('open');
      clickedSummary.setAttribute('aria-expanded', 'true');
      this.currentOpenElement = customDetails;
    }

    // Update `data-expanded` with the currently opened element or 'none'
    this.setAttribute('data-expanded', this.currentOpenElement ? customDetails.id : 'none');
  }

  connectedCallback() {
    // Initialize aria attributes for all <custom-details> elements
    this.querySelectorAll('custom-details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', details.classList.contains('open') ? 'true' : 'false');
      }
      // If the details element has the 'open' class, set it as the current open element
      if (details.classList.contains('open')) {
        this.currentOpenElement = details;
      }
    });

    // Set initial expanded state in `data-expanded`
    this.setAttribute('data-expanded', this.currentOpenElement ? this.currentOpenElement.id : 'none');
  }
}

customElements.define('custom-collapsible-content', CustomCollapsibleContent);

